/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/anchor-is-valid */
import Container from '@components/Container';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { Fragment } from 'react';
import {
  Root,
  Container as ContainerClass,
  Steps,
  Step,
  ActiveStep,
  ActiveOrCompletedStep,
  GoBack,
  HasBackButton,
  StepIcon,
} from './ProgressBanner.module.css';

const ProgressBanner = ({
  className,
  steps,
  currentStep,
  hasBackButton,
  onGoBack,
}) => {
  const { t } = useTranslation(['account', 'common']);
  const router = useRouter();

  const classes = classNames(
    Root,
    { [HasBackButton]: hasBackButton },
    className
  );

  const handleGoBack = () => {
    if (onGoBack) {
      onGoBack();
    } else {
      router.back();
    }
  };

  return (
    <div className={classes}>
      <Container className={ContainerClass}>
        {hasBackButton && (
          <button type="button" onClick={handleGoBack} className={GoBack}>
            {t('back', { ns: 'common' })}
          </button>
        )}
        <ul className={Steps}>
          {steps.map(({ name }, index) => (
            <Fragment key={index}>
              <li
                className={[
                  currentStep > index ? ActiveOrCompletedStep : null,
                  currentStep === index ? ActiveStep : null,
                  Step,
                ].join(' ')}
              >
                {name}
              </li>
              {index !== steps.length - 1 && (
                <FontAwesomeIcon
                  icon={faChevronRight}
                  className={[
                    StepIcon,
                    currentStep > index ? ActiveOrCompletedStep : null,
                  ].join(' ')}
                />
              )}
            </Fragment>
          ))}
        </ul>
      </Container>
    </div>
  );
};

ProgressBanner.defaultProps = {
  currentStep: 0,
  hasBackButton: true,
};

ProgressBanner.propTypes = {
  currentStep: PropTypes.number,
  hasBackButton: PropTypes.bool,
  steps: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export default ProgressBanner;
